import { Helmet } from 'react-helmet-async'

export function SEO({ title, description, image, url }) {
  const defaultTitle = 'KC Hall of O\'Fallon IL | Event Hall and Public Bar'
  const defaultDescription = 'We are a public bar and event hall! Come down for our weekly events and/or book us for your next wedding / event / fundraiser!'
  const siteUrl = 'https://kchallofallon.com'

  const seoTitle = title ? `${title} | ${defaultTitle}` : defaultTitle
  const seoDescription = description || defaultDescription
  const seoImage = image || `${siteUrl}/kchallsign.jpg`
  const seoUrl = url || siteUrl

  return (
    <Helmet>
      <title>{seoTitle}</title>
      <meta name="description" content={seoDescription} />

      {/* Open Graph */}
      <meta property="og:title" content={seoTitle} />
      <meta property="og:description" content={seoDescription} />
      <meta property="og:image" content={seoImage} />
      <meta property="og:url" content={seoUrl} />
      <meta property="og:type" content="website" />

      {/* Twitter */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={seoTitle} />
      <meta name="twitter:description" content={seoDescription} />
      <meta name="twitter:image" content={seoImage} />
    </Helmet>
  )
}
